import apiClient from './client';

export const getPolicy  = (orgId)       => apiClient.get(`/api/orgs/${orgId}/risk-policy`);
export const updatePolicy = (orgId, data) => apiClient.put(`/api/orgs/${orgId}/risk-policy`, data);
